import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { PERM } from '../../../../utils/accessPermissions';

const asUser = (input) => {
	if (!input) return null;
	if (typeof input === 'string') return { role: input };
	return input;
};

const allow = (input, key) => {
	const user = asUser(input);
	if (!user || !Array.isArray(user.access)) return false;
	return user.access.includes(key);
};

/** 对比分析、分享导出 */
export const isStatisticsManagerRole = (userOrRole) => allow(userOrRole, PERM.STATISTICS_COMPARE);

/** 销售员/助理等团队筛选项 */
export const canUseStatisticsTeamFilters = (userOrRole) => allow(userOrRole, PERM.STATISTICS_TEAM_FILTER);

export const canAccessStatisticsPage = (userOrRole) => allow(userOrRole, PERM.MENU_STATISTICS_VIEW);

export const canAccessStatisticsDashboardSection = (userOrRole) => allow(userOrRole, PERM.STATISTICS_DASHBOARD_CHARTS_QUERY);

export const canManageStatisticsDashboard = (userOrRole) => canAccessStatisticsDashboardSection(userOrRole);

export const canAccessStatisticsFinanceDomain = (userOrRole) => allow(userOrRole, PERM.STATISTICS_FINANCE_QUERY);

export const isStatisticsScopedViewerRole = (userOrRole) => {
	const user = asUser(userOrRole);
	if (!user || !Array.isArray(user.access)) return false;
	return user.access.includes(PERM.STATISTICS_SCOPE_OWN) && !user.access.includes(PERM.STATISTICS_TEAM_FILTER);
};

export const canAccessStatisticsOverdueData = (userOrRole) => allow(userOrRole, PERM.STATISTICS_OVERDUE_QUERY);

export const resolveStatisticsDashboardSectionLabel = (userOrRole) => (isStatisticsScopedViewerRole(userOrRole) ? '销售看板' : '经营看板');

export const resolveStatisticsDashboardVariant = (userOrRole) => (isStatisticsScopedViewerRole(userOrRole) ? 'sale' : 'management');

export const resolveStatisticsCapabilities = (user) => {
	const subject = user?.role ? user : { role: user?.role };
	return {
		canAccessPage: canAccessStatisticsPage(subject),
		canAccessDashboardSection: canAccessStatisticsDashboardSection(subject),
		dashboardSectionLabel: resolveStatisticsDashboardSectionLabel(subject),
		dashboardVariant: resolveStatisticsDashboardVariant(subject),
		canManageDashboard: canManageStatisticsDashboard(subject),
		canUseTeamFilters: canUseStatisticsTeamFilters(subject),
		canUseAdvancedFilters: canUseStatisticsTeamFilters(subject),
		canUseCompareAnalysis: isStatisticsManagerRole(subject),
		canShareExport: isStatisticsManagerRole(subject),
		isScopedViewer: isStatisticsScopedViewerRole(subject),
		canAccessFinanceDomain: canAccessStatisticsFinanceDomain(subject),
	};
};

export const useStatisticsCapabilities = () => {
	const userInfo = useSelector((state) => state.auth.userInfo);
	return useMemo(() => resolveStatisticsCapabilities(userInfo), [userInfo]);
};
